const _import = require('@/utils/import/_import_' + process.env.NODE_ENV)

export default [
  {
    path: 'goods',
    component: {
      template: '<div class="content-wrapper"><router-view></router-view></div>'
    },
    name: 'Goods',
    meta: {
      title: 'Товары',
      menuKey: 'ProductsStorage',
      roles: ['ROLE_ADMIN', 'ROLE_WAITER']
    },
    children: [
      {
        path: 'categories',
        component: _import('products/components/categories/list'),
        meta: {
          title: 'Склад и товары',
          menuKey: 'ProductsStorage',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        },
        name: 'Categories.list',
      },
      {
        path: 'categories/create',
        component: _import('products/components/categories/create'),
        name: 'Categories.create',
        meta: {
          menuKey: 'ProductsStorage',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'categories/edit/:id',
        component: _import('products/components/categories/edit'),
        name: 'Categories.edit',
        meta: {
          menuKey: 'ProductsStorage',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: '',
        component: _import('products/components/products/list'),
        name: 'Goods.list',
        meta: {
          title: 'Склад и товары',
          menuKey: 'ProductsStorage',
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'create',
        component: _import('products/components/products/create'),
        name: 'Goods.create',
        meta: {
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      },
      {
        path: 'edit/:id',
        component: _import('products/components/products/edit'),
        name: 'Goods.edit',
        meta: {
          roles: ['ROLE_ADMIN', 'ROLE_WAITER']
        }
      }
    ]

  },
]



// WEBPACK FOOTER //
// ./src/modules/products/routes.js